import { motion } from "framer-motion";
import React from "react";

export default function FadeIn({ children, offY = 0 }) {
  const cardVariants = {
    offscreen: {
      y: offY,
      opacity: 0,
    },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 1.8,
      },
    },
  };

  return (
    <div>
      <motion.div
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.2 }}
        variants={cardVariants}
        style={{ zIndex: 2 }}
      >
        {children}
      </motion.div>
    </div>
  );
}
